import { render, staticRenderFns } from "./Behavior.vue?vue&type=template&id=313898b2"
import script from "./Behavior.vue?vue&type=script&lang=ts"
export * from "./Behavior.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports